import { createContext } from 'react'

const MapContext = createContext({
  maps: {},
  addMap: () => {},
  removeMap: () => {},
  getMap: () => {},
  createMap: () => {},
  mapUpdateContainer: () => {},
})

export default MapContext
